import { render } from "./Ingredient.vue?vue&type=template&id=426999be"
import script from "./Ingredient.vue?vue&type=script&lang=js"
export * from "./Ingredient.vue?vue&type=script&lang=js"

import "./Ingredient.vue?vue&type=style&index=0&id=426999be&lang=css"
script.render = render

export default script